import * as Yup from 'yup';

import { KrkVerificationFormValues } from './krkVerificationForm.types';

export const krkVerificationFormSchema: Yup.ObjectSchema<KrkVerificationFormValues> = Yup.object().shape({
  full_legal_capacity: Yup.string().oneOf(['1', '0']).required(),
  not_convicted: Yup.string().oneOf(['1', '0']).required(),
  proper_agency_performance: Yup.string().oneOf(['1', '0']).required(),
});
